// @ts-nocheck
import { useEffect, useState } from 'react';

import { Text, YStack } from 'tamagui';

import { Header, Footer } from '../components/landing';

const SECTIONS = [
  {
    title: 'Service description',
    content: `Torch is a cross-ecosystem search and productivity platform that connects your existing tools (Gmail, Slack, Notion, GitHub, and others) into a single searchable workspace. Torch also includes built-in productivity apps such as Kanban boards, Calendar, Documents, Wiki, OKRs, and Sprints.`,
  },
  {
    title: 'Account responsibilities',
    content: `You are responsible for maintaining the security of your account credentials. You must provide accurate information when creating your account. You are responsible for all activity that occurs under your account. You must notify us immediately if you suspect unauthorized access to your account. You must be at least 18 years old to use Torch.`,
  },
  {
    title: 'Acceptable use',
    content: `You agree to use Torch only for lawful purposes. You may not use the service to store or transmit malicious code, violate any third-party rights, attempt to gain unauthorized access to our systems, or interfere with other users' use of the service. We reserve the right to suspend accounts that violate these terms.`,
  },
  {
    title: 'Payment terms',
    content: `Free tier accounts have no payment obligations. Paid plans (Pro and Team) are billed monthly or annually via Stripe. Prices are listed on our pricing page and may change with 30 days' notice. Annual plans are billed upfront and include a discount. Refunds are not provided for partial billing periods, but you can cancel at any time to prevent future charges.`,
  },
  {
    title: 'Intellectual property',
    content: `Torch and its original content, features, and functionality are owned by SID Technologies and are protected by applicable intellectual property laws. Your data remains yours. We do not claim ownership of any content you create or connect through the service. You grant us a limited license to process your data solely to provide the service.`,
  },
  {
    title: 'Limitation of liability',
    content: `Torch is provided "as is" without warranties of any kind, either express or implied. SID Technologies shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service. Our total liability for any claim arising from these terms shall not exceed the amount you paid us in the 12 months preceding the claim.`,
  },
  {
    title: 'Termination',
    content: `You may close your account at any time from your account settings. We may suspend or terminate your account if you violate these terms or if required by law. Upon termination, your right to use the service ceases immediately. We will delete your data in accordance with our privacy policy.`,
  },
  {
    title: 'Changes to terms',
    content: `We may update these terms from time to time. We will notify you of material changes via email or a notice within the product at least 30 days before they take effect. Continued use of Torch after changes take effect constitutes acceptance of the updated terms.`,
  },
  {
    title: 'Governing law',
    content: `These terms are governed by the laws of the State of Delaware, United States, without regard to conflict of law principles.`,
  },
  {
    title: 'Contact',
    content: `If you have questions about these terms, contact us at dans@romans.dev.`,
  },
];

export default function TermsPage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <YStack backgroundColor="$background" minHeight="100vh">
      <Header />

      <YStack paddingTop={140} paddingHorizontal="$5" gap="$8" paddingBottom={80}>
        <YStack maxWidth={800} alignSelf="center" width="100%">
          {/* Page header */}
          <YStack marginBottom={48}>
            <Text
              fontSize={isMobile ? 30 : 44}
              fontWeight="700"
              letterSpacing={-1.5}
              lineHeight={isMobile ? 36 : 52}
              color="$color12"
            >
              Terms of Service
            </Text>
            <Text fontSize={14} color="$color8" marginTop="$3">
              Effective date: March 2026
            </Text>
          </YStack>

          <Text fontSize={16} color="$color10" lineHeight={26} marginBottom={40}>
            These terms govern your use of Torch, a product of SID Technologies. By using Torch, you
            agree to these terms. Please read them carefully.
          </Text>

          {/* Sections */}
          <YStack gap="$6">
            {SECTIONS.map((section) => (
              <YStack key={section.title} gap="$2">
                <Text
                  fontSize={20}
                  fontWeight="600"
                  color="$color12"
                  letterSpacing={-0.3}
                >
                  {section.title}
                </Text>
                <Text fontSize={15} color="$color10" lineHeight={26}>
                  {section.content}
                </Text>
              </YStack>
            ))}
          </YStack>
        </YStack>
      </YStack>

      <Footer />
    </YStack>
  );
}
